import React, { FC, ReactNode } from 'react';
import skyImage from '../assets/images/background/SkyWithClouds.png';
import skyBgMobile from '../assets/images/background/SkyWithCloudsMobile.png';
import rocksImage from '../assets/images/background/RocksWithGrass.png';
import treeImage from '../assets/images/background/TreeWithBird.png';

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="relative min-h-screen w-full bg-gradient-to-b from-[#a4c8e1] via-[#dceaf3] to-white flex flex-col items-center overflow-x-hidden">
      <div className="absolute top-0 left-0 w-full z-[1] leading-none mix-blend-multiply opacity-80 pointer-events-none">
        <img src={skyImage} alt="" className="w-full h-auto object-cover md:min-h-[220px] hidden md:block" />
        <img src={skyBgMobile} alt="" className="w-full h-auto object-cover md:hidden" />
      </div>

      <div className="relative z-10 w-full flex-1 flex justify-center items-center py-4 md:py-6 lg:py-8">
        {children}
      </div>

      <div className="absolute bottom-0 left-0 w-full pointer-events-none z-[5] flex justify-between items-end">
        <img src={rocksImage} alt="" className="max-w-[140px] md:max-w-[120px] lg:max-w-[150px] xl:max-w-[180px] 2xl:max-w-[220px] h-auto" />
        <img src={treeImage} alt="" className="max-w-[90px] md:max-w-[140px] lg:max-w-[180px] xl:max-w-[220px] 2xl:max-w-[260px] h-auto" />
      </div>

      <div className=" w-full text-center z-20 pt-[10px] pb-[15px] md:pb-[20px]">
        <p className="font-['Lexend',sans-serif] font-normal text-[10px] md:text-[14px] leading-[1.7] text-[#a7a7a7c4] m-0 max-w-[36%] md:max-w-[100%] mx-auto ">Copyright &copy; {new Date().getFullYear()} EmployProTech™. All Rights Reserved</p>
      </div>

    </div>
  );
};

export default AuthLayout;
